var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectTableDialog',{attrs:{"title":_vm.title,"searchColumns":_vm.searchColumns,"columnList":_vm.columnList,"defaultVisible":_vm.defaultVisible,"API":_vm.API,"width":"1200px","columnWidth":100,"extraData":_vm.extraData,"checkRowKeys":_vm.checkRowKeys,"propCode":"contractNo"},on:{"close":_vm.close,"confirm":_vm.confirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }